export default __webpack_public_path__ + "static/media/approval.1a0708a2.svg";